import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { InfoToastService } from '../info/info-toast.service';

/** I 401 li gestisce l'AuthInterceptor di @arpes-is/angular-20-auth (verifica sessione e redirect). */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const info = inject(InfoToastService);
  return next(req).pipe(
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status !== 401) {
        info.addInfo({
          type: 'error',
          group: String(error.status || 'API'),
          text: error.error?.detail || error.error?.description || 'Errore API',
        });
      }
      return throwError(() => error);
    }),
  );
};
